import styled from 'styled-components';
import { device } from "../../themes/Breakpoints";


export const DraftConfigWrap = styled.section`
	margin-top: 25px;
	margin-bottom: 200px;
	.line {
		margin-top: 0px;
	}
  @media only screen and (max-width: 1023px) {
    margin-bottom: 25px;
  }
`;
export const DraftContainer = styled.div``;
export const DraftHeading = styled.div`
	margin-bottom: 23px;
	display: flex;
	flex-direction: column;
	align-items: center;
	.title {
		color: #000000;
		font-size: 36px;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-weight: 400;
		margin-bottom: 0;
	}
	p {
		color: #3e464f;
		font-size: 20px;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-weight: 400;
	}
  @media only screen and (max-width: 700px) {
    .title {
      font-size:28px;
    }
  }
`;

export const DraftSettings = styled.div`
	border-radius: 12px;
	background: #fff;
	padding: 40px 24px;
	display: flex;
  @media only screen and (max-width: 700px) {
    flex-wrap: wrap;
  }
`;

export const DraftInputs = styled.div`
	height: 100%;
	padding-top: 40px;
	padding-right: 36px;
	border-right: 1px solid #e8ebef;
	max-width: 416px;
	width: 100%;
	.draft-input-div {
		max-width: 416px;
		width: 100%;
		padding-bottom: 24px;
		border-bottom: 1px solid #e8ebef;
		display: flex;
		flex-direction: column;
		margin-bottom: 24px;
	}
	.draft-label-name {
		color: #000;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		font-family: 'Saira Semi Condensed', sans-serif;
		text-transform: capitalize;
		margin-bottom: 16px;
	}
	.draft-label-title {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		text-transform: capitalize;
		margin-bottom: 24px;
	}
	.draft-label {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		text-transform: capitalize;
		margin-bottom: 8px;
	}
	input {
		padding: 9px 12px;
		width: 100%;
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		border-radius: 3px;
		border: 1px solid #e8ebef;
	}
	input::placeholder {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
	}
  @media only screen and (max-width: 1439px) {
    padding-right: 12px;
  }
  @media only screen and (max-width: 1023px) {
    .draft-label-name {
      font-size:18px;
      line-height: 26px;
      margin-bottom: 8px;
    }
    .draft-input-div {
      margin-bottom: 12px;
    }
    .draft-label-title {
      font-size:18px;
      line-height: 26px;
      margin-bottom: 12px
    }
  }
  @media only screen and (max-width: 700px) {
   border-right: unset;
    max-width: unset;
    padding-top: 0;
    .draft-input-div {
      max-width: unset;
    }
  }
  
`;

export const DraftPositions = styled.div`
	height: 100%;
	padding-left: 22px;
	padding-right: 36px;
	border-right: 1px solid #e8ebef;
	.row-position {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-bottom: 20px;
	}
	.position-name {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 600;
		line-height: 30px;
		text-transform: capitalize;
		white-space: nowrap;
	}
  @media only screen and (max-width: 1439px) {
    padding-left: 12px;
    padding-right: 12px;
  }
  
  @media only screen and (min-width: 581px) and (max-width: 1439px) {
    .row-position{
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 1023px) {
    .position-name {
      font-size: 18px;
      line-height: 26px;
    }
  }
  @media only screen and (min-width: 581px) and (max-width: 1023px) {
  .position-name{
    white-space: wrap;
  }
    .row-position {
      margin-bottom: 10px;
    }
  }
  @media only screen and (max-width: 700px) {
    padding-left: 0px;
  }
  @media only screen and (max-width: 580px) {
    width: 100%;
    margin-top: 22px;
    margin-bottom: 22px;
    border-right: unset;
    .row-position{
      flex-direction: unset;
    }
    .position-name{
      white-space: nowrap;
    }
  }
  @media only screen and (max-width: 424px) {
    .position-name{
      white-space: wrap;
    }
  }
`;
export const ColorDiv = styled.div`
	border-radius: 1px;
	width: 6px;
	height: 36px;
	background-color: ${props => props.color || 'defaultColor'};
`;
export const DraftBots = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: 36px;

	.bot-section {
		max-width: 230px;
		width: 100%;
	}
	.bot-section:first-child {
		max-width: 800px;
		width: 100%;
	}
	.bots {
		display: flex;
		flex-wrap: wrap;
		gap: 18px;
		width: 100%;
	}
	.bot-row {
		display: flex;
		gap: 18px;
	}
	.bot-part {
		margin-bottom: 16px;
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.bot-part input {
		width: 100%;
		height: 20px;
		max-width: 20px;
	}
	.label {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 24px;
		text-transform: capitalize;
		white-space: nowrap;
	}
	.slider-box {
		width: 100%;
		margin-left: 10px;
	}
	.main-label {
		white-space: nowrap;
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 600;
		line-height: 30px;
		text-transform: capitalize;
	}
	.m-btn {
		margin-bottom: 40px;
	}
	a,
	button {
		display: flex;
		align-items: center;
		gap: 2px;
		cursor: pointer;
		padding: 5.5px 24px;
		background-color: #004ea3;
		font-family: 'Saira Semi Condensed', sans-serif;
		color: #ffffff;
		text-decoration: none;
		font-weight: 400;
		font-size: 20px;
		line-height: 31px;
		border-radius: 3px;
		opacity: 0.9;
		transition: all 0.3s ease;
		margin-top: 40px;
		width: fit-content;
		align-self: flex-end;
		margin-right: 40px;
		:hover {
			opacity: 1;
		}
	}
  @media only screen and (max-width: 1439px) {
    padding-left: 12px;
    max-width: 280px;
    .bot-part {
      flex-wrap: wrap;
    }
  }
  @media only screen and (max-width: 1023px) {
    .bot-part {
      margin-bottom: 6px;
    }
    .bots{
      gap: 12px;
    }
  }
  @media only screen and (max-width: 580px) {
    padding-left: 0;
    a,
    button {
      align-self: flex-start;
      margin-top: 20px;
      font-size: 18px;
      line-height: 26px;
    }
  }
`;

export const DraftNamesContainer = styled.div`
	border-radius: 12px;
	background: #fff;
	padding: 40px 24px;
	display: flex;
	flex-direction: column;
	a,
	button {
		display: flex;
		align-items: center;
		gap: 2px;
		cursor: pointer;
		padding: 5.5px 24px;
		background-color: #004ea3;
		font-family: 'Saira Semi Condensed', sans-serif;
		color: #ffffff;
		text-decoration: none;
		font-weight: 400;
		font-size: 20px;
		line-height: 31px;
		border-radius: 3px;
		opacity: 0.9;
		transition: all 0.3s ease;
		width: fit-content;
		align-self: flex-end;
		margin-right: 40px;
		:hover {
			opacity: 1;
		}
		:disabled {
			cursor: not-allowed;
		}
	}
	.title {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		margin-bottom: 16px;
	}
`;
export const DraftNames = styled.div`
	display: flex;
	width: 100%;
	gap: 24px;
	margin-bottom: 80px;
    flex-wrap: wrap;
	//overflow-x: auto;
    //padding-bottom: 25px;
  .name-input-div {
		max-width: 342px;
		width: 100%;
		min-width: 220px;
		padding-right: 24px;
		display: flex;
		flex-direction: column;
		border-right: 1px solid #e8ebef;
	}
	.name-input-div:last-child {
		border-right: none;
	}
	.name-label {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		margin-bottom: 16px;
	}
	input {
		padding: 9px 12px;
		width: 100%;
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		border-radius: 3px;
		border: 1px solid #e8ebef;
	}
	input::placeholder {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
	}
	button.disabled {
		cursor: not-allowed;
	}
	.botName {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		margin-bottom: 16px;
		max-width: 342px;
		width: 100%;
		min-width: 220px;
		padding-right: 24px;
		border-right: 1px solid #e8ebef;
	}
  @media ${device.laptopM} {
    gap: 20px;
    .name-input-div {
      max-width: 320px;
      padding-right: 20px;
    }
    .botName {
      max-width: 320px;
      padding-right: 20px;
    }
  }
  @media ${device.laptop} {
    gap: 20px;
    .name-input-div {
      max-width: 280px;
      padding-right: 20px;
    }
    .botName {
      max-width: 280px;
      padding-right: 20px;
    }
  }
  @media ${device.tabletL} {
    gap: 14px;
    .name-input-div {
      max-width: 280px;
      padding-right: 14px;
    }
    .botName {
      max-width: 280px;
      padding-right: 14px;
    }
  }
  @media ${device.tablet} {
    gap: 14px;
    margin-bottom: 40px;
    .name-input-div {
      max-width: 280px;
      padding-right: 14px;
    }
    .botName {
      max-width: 280px;
      padding-right: 14px;
    }
  }
  @media only screen and (min-width: 600px) and (max-width: 767px){
    .name-input-div {
      max-width: 250px;
    }
    .botName {
      max-width: 250px;
    }
  }
  @media ${device.mobileL} {
    gap: 14px;
    margin-bottom: 40px;
    .name-input-div {
      padding-right: 14px;
    }
    .name-label {
      font-size: 18px;
      margin-bottom: 8px;
    }
    .botName {
      padding-right: 14px;
      font-size: 18px;
      margin-bottom: 8px;
    }
  }
  @media ${device.mobileM} {
    gap: 14px;
    margin-bottom: 20px;
    .name-input-div {
      padding-right: 14px;
    }
    .name-label {
      font-size: 18px;
      margin-bottom: 8px;
    }
    .botName {
      padding-right: 14px;
      font-size: 18px;
      margin-bottom: 8px;
    }
  }
  @media ${device.mobileS} {
    gap: 14px;
    margin-bottom: 20px;
    .name-input-div {
      padding-right: 14px;
    }
    .name-label {
      font-size: 18px;
      margin-bottom: 8px;
    }
    .botName {
      padding-right: 14px;
      font-size: 18px;
      margin-bottom: 8px;
    }
  }
`;
